import axios from 'axios'
import i18n from '@/plugins/i18n'

export default {
  // Получение списка БСО
  getProductionBsos (filters) {
    let filter = ''

    for (const field in filters) {
      if (filters[field] !== undefined) {
        filter += `${field}=${filters[field]}&`
      }
    }
    return axios.get(`${i18n.locale}/api/bso/getProductionBsos/?${filter}`)
  },
  // Получение данных для формы создание БСО
  getBsoFormData () {
    return axios.get(`${i18n.locale}/api/bso/getBsoFormData`)
  },
  // Создание БСО
  createProductionBso (data) {
    return axios.post(`${i18n.locale}/api/bso/createProductionBso`, data)
  },
  // Получение данных для страницы накладные БСО
  getInvoiceBsoFilterFormData () {
    return axios.get(`${i18n.locale}/api/bso/getInvoiceBsoFilterFormData`)
  },
  // Получение данных для страницы накладные БСО для представительств
  getInvoiceBsoDepartmentFilterFormData () {
    return axios.get(`${i18n.locale}/api/bso/getInvoiceBsoDepartmentFilterFormData`)
  },
  // Список накладных
  listInvoiceBso (filters) {
    let filter = ''

    for (const field in filters) {
      if (filters[field] !== undefined) {
        filter += `${field}=${filters[field]}&`
      }
    }

    return axios.get(`${i18n.locale}/api/bso/getInvoiceBsos/?${filter}`)
  },
  // Создание накладной БСО
  createInvoiceBso () {
    return axios.get(`${i18n.locale}/api/bso/createInvoiceBso`)
  },
  // Получение данных для страницы накладные БСО
  getInvoiceBsoFormData () {
    return axios.get(`${i18n.locale}/api/bso/getInvoiceBsoFormData`)
  },
  // Получение данных для просмотра накладной БСО
  getInvoiceBsoInfo (id) {
    return axios.get(`${i18n.locale}/api/bso/getInvoiceBsoInfo/${id}`)
  },
  // Обновление накладной БСО
  editInvoiceBso (id, statusId, data) {
    return axios.post(`${i18n.locale}/api/bso/editInvoiceBso/${id}/${statusId}`, data)
  },
  // Удаление накладной БСО
  deleteInvoiceBso (id) {
    return axios.delete(`${i18n.locale}/api/bso/deleteInvoiceBso/${id}`)
  },
  // печать в ворд
  printInvoiceBso (id) {
    return axios.get(`${i18n.locale}/api/bso/printInvoiceBso/${id}`, { responseType: 'arraybuffer' })
  },
  // Создание базового БСО накладной
  createBaseBsoInvoice (id) {
    return axios.get(`${i18n.locale}/api/bso/createBaseBsoInvoice/${id}`)
  },
  // Обновление базового БСО накладной
  editBaseBsoInvoice (id, data) {
    return axios.post(`${i18n.locale}/api/bso/editBaseBsoInvoice/${id}`, data)
  },
  // Удаление базового БСО накладной
  deleteBaseInvoiceBso (id) {
    return axios.delete(`${i18n.locale}/api/bso/deleteBaseBsoInvoice/${id}`)
  },
  // Удаление пачки БСО
  deleteProductionBso (id) {
    return axios.delete(`${i18n.locale}/api/bso/deleteProductionBso/${id}`)
  },
  // Получение данных для страницы накладные БСО
  getBsoFilterFormData () {
    return axios.get(`${i18n.locale}/api/bso/getBsoFilterFormData`)
  },
  // Список накладных
  listBso (filters) {
    let filter = ''

    for (const field in filters) {
      if (filters[field] !== undefined) {
        filter += `${field}=${filters[field]}&`
      }
    }

    return axios.get(`${i18n.locale}/api/bso/getBsos/?${filter}`)
  },
  // Изменение статуса БСО
  changeBsoByStatus (id, status, data) {
    return axios.post(`${i18n.locale}/api/bso/changeByStatus/${id}/${status}`, data)
  }
}
